export default __webpack_public_path__ + "static/media/sanetyzer.27707a44.png";